import React, { useState } from "react";
import { Button } from '@mui/material';
import AlphabetGrid from '../AlphabetGrid';
import Grid from "../Grid";
import AlphabetCell from '../AlphabetCell'
import CustomButton from "../CustomButton";
import KeylessCipherEncryption from "./KeylessCipherEncryption";
import KeylessCipherDecryption from "./KeylessCipherDecryption";

var pos = [];
var cipherColPos = [];

var cipherPositionsList = []
var cipherSelectedPosList = []

const KeylessCipherSimulation = () => {
  const [isEncryptMode, setIsEncryptMode] = useState(true);
  const [fenceStructure, setFenceStructure] = useState([]);

  const [plainText, setPlainText] = useState("")
  const [cipherText, setCipherText] = useState("")
  const [plainColIndex, setPlainColIndex,] = useState("")
  const [plainPositions, setPlainPositions] = useState([])
  const [key, setKey] = useState("")
  const [clickedSimulate, setClickedSimulate] = useState(false)
  const [isSimulating, setIsSimulating] = useState(false);
  const [encryptionDone, setEncryptionDone] = useState(false);
  const [isKeyValid, setIsKeyValid] = useState(true)

  // For Decryption
  const [decryptionPlainText, setDecryptionPlainText] = useState("")
  const [cipherPositions, setCipherPositions] = useState([])
  const [cipherSelectedPos, setCipherSelectedPos] = useState([])

  // For Decryption


  function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  const toggleMode = () => {
    setIsEncryptMode(!isEncryptMode);
    setFenceStructure([]);
  };

  const encrypt = async (str, s) => {
    pos = [];
    cipherColPos = [];
    cipherPositionsList = [];
    cipherSelectedPosList = [];
    setEncryptionDone(false)
    setPlainColIndex("")
    setCipherText("")
    setDecryptionPlainText("")
    setCipherPositions([])
    setCipherSelectedPos([])
    var dummy = "-".repeat(str.length);

    setKey(s.toString())

    let fence = [];
    for (let i = 0; i < s; i++) {
      fence.push([]);
    }

    let rail = 0;
    let direction = 1;

    for (let i = 0; i < str.length; i++) {
      let plainArray = dummy.split('');
      plainArray[i] = str[i];
      // console.log("Dummy: ", dummy);
      // console.log("Updated plaintext : ", plainArray);
      dummy = plainArray.join('');
      setPlainText(dummy);
      pos.push(rail);
      cipherColPos.push(i)
      setPlainPositions(pos)
      fence[rail].push([str[i], i, rail]);

      rail += direction;
      if (rail === 0 || rail === s - 1) {
        direction = -direction;
      }

      await sleep(500).then(() => { })
    }

    console.log("FENCE : ", fence)

    let result = '';
    for (let rail of fence) {
      let row = []
      for (let char of rail) {
        row.push(char[0])
        result += char[0]
        setPlainColIndex(char[1])
        setCipherText(result)
        await sleep(500).then(() => { })
      }
    }

    setCipherText(result)

    console.log("Result : ", result);
    setEncryptionDone(true)
    setFenceStructure(fence);

    // ****************** Decryption Starts ******************

    for (let i = 0; i < fence.length; i++) {
      for (let j = 0; j < fence[i].length; j++) {
        cipherPositionsList.push(["-", fence[i][j][1], fence[i][j][2]]);
      }
    }

    var posCount = 0;
    for (let i = 0; i < fence.length; i++) {
      for (let j = 0; j < fence[i].length; j++) {
        cipherPositionsList[posCount] = fence[i][j];
        var newList = [];
        for (let k = 0; k < cipherPositionsList.length; k++) {
          newList.push(cipherPositionsList[k])
        }
        setCipherPositions(newList);
        posCount++;
        await sleep(500).then(() => { })
      }
    }

    let cipherRail = 0;
    let cipherDirection = 1;

    for (let i = 0; i < str.length; i++) {
      cipherSelectedPosList.push(cipherRail);
      var newList = [];
      for (let k = 0; k < cipherSelectedPosList.length; k++) {
        newList.push(cipherSelectedPosList[k])
      } 
      setCipherSelectedPos(newList)
      var newPlain = str.substring(0, i+1);
      setDecryptionPlainText(newPlain)

      fence[cipherRail].push([str[i], i, cipherRail]);
      cipherRail += cipherDirection;
      if (cipherRail === 0 || cipherRail === s - 1) {
        cipherDirection = -cipherDirection;
      }
      await sleep(500).then(() => { })
    }

    setIsSimulating(false);
  };

  function handleSubmit(e) {

    // Prevent the browser from reloading the page
    e.preventDefault();
    if (!isSimulating) {
      // Read the form data
      const form = e.target;
      const formData = new FormData(form);

      // You can pass formData as a fetch body directly:
      // fetch('/some-api', { method: form.method, body: formData });

      // Or you can work with it as a plain object:
      const formJson = Object.fromEntries(formData.entries());
      console.log(formJson);
      var str = formData.get("plaintext").toUpperCase();
      var k = parseInt(formData.get("key"));
      if (k < 2 || k > str.length) {
        setIsKeyValid(false);
      } else {
        setIsKeyValid(true)
        var res = encrypt(str, k);
        setClickedSimulate(true)
        setIsSimulating(true);
        console.log(res);
      }
    }
  }

  return (
    <>
      <form method="post" onSubmit={handleSubmit}>
        <label>
          Plain Text (only alphabets, without spaces):
          <input pattern="[a-zA-Z]+" style={{ textTransform: "uppercase" }} required={true} name="plaintext" />
        </label>
        <label>
          Key/Rails:
          <input name="key" required={true} type="number" />
        </label>
        <CustomButton type="submit" isSimulating={isSimulating}>{isSimulating ? 'Simulating...' : 'Simulate'}</CustomButton>
      </form>
      <p style={{ display: isKeyValid ? "none" : "inline", color: "red" }}>Invalid Key! Key should be greater than 1 and less than or equal to plaintext</p>
      <br />
      <div style={{ display: clickedSimulate ? "block" : "none" }} >
        <KeylessCipherEncryption plainText={plainText} cipherText={cipherText} positions={plainPositions} rails={key} selectedCharCol={plainColIndex} />
      </div>
      <div style={{ display: encryptionDone ? "block" : "none" }} >
        <hr />
        <KeylessCipherDecryption plainText={decryptionPlainText} cipherText={cipherText} fence={cipherPositions} rails={key} selectedPos={cipherSelectedPos} />
      </div> 
    </>
  )
}



export default KeylessCipherSimulation